'use client'

import useLogin from '@hook/useLogin'
import useMessage from '@hook/useMessage'
import { fetchPost } from '@lib/fetch/client'
import { LoadingButton } from '@mui/lab'
import clsx from 'clsx'
import { useTranslations } from 'next-intl'
import { useCallback, useEffect } from 'react'
import { useAsyncFn, useBoolean } from 'react-use'

export default function RemindButton({
  children,
  subscribed: _subscribed,
  eventId,
  className = 'h-pix-30'
}) {
  const ts = useTranslations('live')
  const { isLogin, openSigninDialog } = useLogin()
  // 是否已订阅
  const [subscribed, toggleSubscribe] = useBoolean(_subscribed)
  useEffect(() => toggleSubscribe(Boolean(_subscribed)), [_subscribed, toggleSubscribe])

  // 订阅
  const { message } = useMessage()
  const [remindState, remindHandle] = useAsyncFn(async () => {
    const res = await fetchPost(`meetup/events/${eventId}/subscribe`).catch((err) => {
      message(err)
      return false
    })
    if (res !== false) {
      toggleSubscribe(true)
    }
  })
  const clickHandle = useCallback((event) => {
    event.preventDefault()
    event.stopPropagation()
    if (subscribed) return

    if (!isLogin) {
      openSigninDialog()
      return
    }

    remindHandle()
  }, [remindHandle, subscribed, isLogin, openSigninDialog])

  return (
    <LoadingButton
      sx={{ borderRadius: 4, backgroundColor: subscribed ? undefined : 'white' }}
      className={clsx(className, { 'hover:bg-white': !subscribed })}
      variant={subscribed ? 'contained' : 'outlined'}
      onClick={clickHandle}
      loading={remindState.loading}
      data-noprogress
    >
      {subscribed ? ts('subscribed') : children}
    </LoadingButton>
  )
}
